export function validate(record) {
    const errors = [];

    if (!record.identifier || record.identifier.trim() === "") {
        errors.push({ field: 'identifier', message: 'O Identificador pallet é obrigatório!' });
    }

    if (!record.oidPalletStandard || record.oidPalletStandard === "") {
        errors.push({ field: 'oidPalletStandard', message: 'O padrão de pallet é obrigatório!' });
    }

    const result = {
        ok: errors.length === 0,
        errors,
        record
    }

    return new Promise((resolve, reject) => {
        const action = result.ok ? resolve : reject;
        return action(result);
    })
}